module.exports = __webpack_public_path__ + "img/1920x793px.675f2836.png";